/** Trigger a browser download for a Blob via a transient object URL. */
export function downloadBlobAs(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = filename;
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  URL.revokeObjectURL(url);
}

/** Trigger a download for in-memory bytes (xlsx workbook, zip archive, …). */
export function downloadBytes(
  bytes: Uint8Array,
  filename: string,
  mime: string,
): void {
  // Copy into an ArrayBuffer-backed view so the bytes satisfy BlobPart (never SharedArrayBuffer).
  downloadBlobAs(new Blob([new Uint8Array(bytes)], { type: mime }), filename);
}

/** Trigger a download for string content (csv, json, plain text, …). */
export function downloadText(
  content: string,
  filename: string,
  mime: string,
): void {
  downloadBlobAs(new Blob([content], { type: mime }), filename);
}
